.question {
  display: flex;
  flex-direction: column;
  gap: var(--tuna-spacing-3);
  padding: var(--tuna-spacing-4);
}

.header {
  display: flex;
  align-items: center;
  justify-content: flex-end;
}

.scoreChip {
  padding: var(--tuna-spacing-1) var(--tuna-spacing-2);
  font-size: var(--tuna-typography-caption-fontSize);
  background: var(--tuna-surface-elevated);
  border: 1px solid var(--tuna-border-default);
  border-radius: var(--tuna-shape-borderRadius);
}

.prompt {
  margin: 0;
  font-size: var(--tuna-typography-body2-fontSize);
  color: var(--tuna-content-muted);
}

.actionRow {
  display: flex;
  align-items: center;
  justify-content: flex-start;
}

.cardGrid {
  display: grid;
  grid-template-columns: repeat(4, 1fr);
  gap: var(--tuna-spacing-2);
}

@media (max-width: 640px) {
  .cardGrid {
    grid-template-columns: repeat(3, 1fr);
  }
  .actionRow {
    justify-content: stretch;
  }
}

@media (max-width: 400px) {
  .cardGrid {
    grid-template-columns: repeat(2, 1fr);
  }
}
